import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

// Complete onboarding (first login profile setup)
export const completeOnboarding = async (token, data) => {
  log("welcome in completeOnboarding")

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/complete_onboarding_api'

    const result = await axios.post(url, data, { headers })
    log("result.data from completeOnboarding")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in completeOnboarding:")
    log(err)
    return { error: true, message: err.message || "Network error" }
  }
}
